import React from 'react';
import { usePathContext } from '../../context/PathContext.js';
import deriveNodeNavigationDetails from '../../helpers/deriveNodeNavigationDetails.js';
import styles from './styles.css.js';

var LoginLinkHandler = function LoginLinkHandler() {
  var pathContext = usePathContext();
  /**
   * The default 'Log in here' link is assuming a consumer implementation using a `then=` link that
   * redirects the user back into a full page path flow. In the event that we want to return them
   * to somewhere specific, the `onRequestLogin` prop should be used.
   */

  var nodeNavigation = pathContext.activeNode && deriveNodeNavigationDetails(pathContext.activeNode);

  if (nodeNavigation) {
    return React.createElement("span", {
      className: styles.loginLink,
      onClick: function onClick() {
        pathContext.onRequestLogin({
          nodeSlugOrId: (nodeNavigation === null || nodeNavigation === void 0 ? void 0 : nodeNavigation.nodeSlug) || (nodeNavigation === null || nodeNavigation === void 0 ? void 0 : nodeNavigation.nodeId),
          pathGraphFlowId: pathContext.pathGraphFlowId,
          pathGraphFlowSlug: nodeNavigation === null || nodeNavigation === void 0 ? void 0 : nodeNavigation.pathSlug
        });
      }
    }, "Log in here.");
  }
  /**
   * In this case for some (unlikely) reason we weren't able to parse the node navigation details
   */


  return null;
};

export default LoginLinkHandler;
//# sourceMappingURL=index.js.map
